import React from "react";
import './PreHome.scss';
import { Card } from 'antd';
import { useNavigate } from "react-router-dom";

const PreHome = (props)=>{
    
    const navigate = useNavigate();
    const handleClick=(des)=>{
        navigate(des);
    }

    return (
        <div className="pre-home-container">
            <ul className="row-container">
                <li  className="row-first-card" onClick={()=>handleClick('/home')}>
                    <p>Intelligent Chat</p>
                </li>
                
                <li onClick={()=>handleClick('/quiz-generator')}>
                    <p>Quiz Generator</p>
                </li>
            </ul>
            <ul className="row-container">
                <li className="row-first-card" onClick={()=>handleClick('/quiz-set')}>
                    <p>Quiz Practice</p>
                </li>
                
                <li onClick={()=>handleClick('/public-quiz')}>
                    <p>G1 Test</p>
                </li>
            </ul>
        </div>
    );
}

export default PreHome;
